module.exports = __webpack_public_path__ + "static/media/boy-2.11e4ed8a.svg";